// Whether this browser can run the engine: WebGL for the scene and FontFace for its bundled
// face. Checked before the scene's chunk is fetched, so a browser without them (or a test's
// jsdom) never downloads Pixi and is told why the picture is missing.
export function engineSupported(): boolean {
  return (
    typeof FontFace !== "undefined" &&
    (typeof WebGL2RenderingContext !== "undefined" || typeof WebGLRenderingContext !== "undefined")
  );
}
